import React from 'react';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ActualRouteMarker from '../../../../mapComponents/Markers/NextStopCompliance/ActualRouteMarker';
import PlannedRouteMarker from '../../NextStopCompliance/NextStopComplianceMap/Legend/LegendMarker/PlannedRouteMarker';

const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 3,
    position: 'absolute',
    pointerEvents: 'auto',
    top: 2,
    left: 5,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.ModalBGColor
  },
  legendDetailsContainer: {
    padding: 1
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 5,
    padding: 4,
    width: 125
  },
  detailsLabel: {
    color: theme.ModalHeaderTextColor,
    fontSize: theme.dispatchCardTextFontSize,
    marginLeft: 5,
    marginRight: 5
  },
  markerContainer: {
    width: 16,
    height: 16,
    border: `1px solid ${theme.palette.primary.main}`
  },
  pickupContainerWhite: {
    backgroundColor: theme.selectedStopMarkerColor,
    border: `1px solid ${theme.palette.primary.main}`
  },
  deliveryContainerWhite: {
    backgroundColor: theme.selectedStopMarkerColor,
    borderRadius: 11,
    border: `1px solid ${theme.palette.primary.main}`
  },
  pickupContainer: {
    backgroundColor: theme.palette.primary.main
  },
  deliveryContainer: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 11
  }
});

const MapLegend = ({ classes, theme, enableDriverActualRoute }) => {
  return (
    <Paper className={classes.outerMostWrapper}>
      <div id="legendDetails" className={classes.legendDetailsContainer}>
        <div className={classes.details}>
          <div className={`${classes.markerContainer} ${classes.deliveryContainer}`}></div>
          <div className={classes.detailsLabel}>Completed Delivery</div>
        </div>
        <div className={classes.details}>
          <div className={`${classes.markerContainer} ${classes.deliveryContainerWhite}`}></div>
          <div className={classes.detailsLabel}>Pending Delivery</div>
        </div>
        <div className={classes.details}>
          <div className={`${classes.markerContainer} ${classes.pickupContainer}`}></div>
          <div className={classes.detailsLabel}>Completed Pickup</div>
        </div>
        <div className={classes.details}>
          <div className={`${classes.markerContainer} ${classes.pickupContainerWhite}`}></div>
          <div className={classes.detailsLabel}>Pending Pickup</div>
        </div>
        <div className={classes.details}>
          <PlannedRouteMarker  color={theme.palette.primary.main} size={18}/>
          <div className={classes.detailsLabel}>Planned Route</div>
        </div>
        {enableDriverActualRoute && <div className={classes.details}>
          <ActualRouteMarker size={18} color={theme.actualRouteColor}/>
          <div className={classes.detailsLabel}>Actual Route</div>
        </div>}
      </div>
    </Paper>
  );
};

export default withStyles(styles)(MapLegend);
